<template>
  <div class="slots">
    <van-popup v-model="showPop" round :style="{width:'80%'}" :close-on-click-overlay="false" get-container="body">
      <div class="content">
        <van-form 
          :show-error-message="false" 
          validate-trigger="onSubmit" 
          validate-first
          input-align="right"
          ref="form"
          class="form"
        >
          <van-field 
            required  
            label="背景图"
            v-model="homePage.homeBackImg"
            :rules="[{ required: true, message: '请上传背景图' }]">
          >
            <template #input>
              <van-uploader
                :max-count="1" 
                :before-read="beforeImgUpload" 
                :fileList="homePage.homeBackImgArr" 
                :after-read="(e) => uploadImg(e, 'homeBackImg')"
                @delete="(e) => deleteImg('homeBackImg')"
              />
            </template>
          </van-field>
          <van-field 
            required  
            label="标题"
            v-model="homePage.homeTitleImg"
            :rules="[{ required: true, message: '请上传标题图' }]"
          >
            <template #input>
              <van-uploader
                :max-count="1" 
                :before-read="beforeImgUpload" 
                :fileList="homePage.homeTitleImgArr" 
                :after-read="(e) => uploadImg(e, 'homeTitleImg')"
                @delete="(e) => deleteImg('homeTitleImg')"
              />
            </template>
          </van-field>
          <van-field 
            required  
            label="按钮"
            v-model="homePage.homeBtnImg"
            :rules="[{ required: true, message: '请上传按钮图' }]"
          >
            <template #input>
              <van-uploader
                :max-count="1" 
                :before-read="beforeImgUpload" 
                :fileList="homePage.homeBtnImgArr" 
                :after-read="(e) => uploadImg(e, 'homeBtnImg')"
                @delete="(e) => deleteImg('homeBtnImg')"
              />
            </template>
          </van-field>
          <van-field 
            required  
            label="主视觉图"
            v-model="homePage.homeVisionImg"
            :rules="[{ required: true, message: '请上主视觉图' }]"
          >
            <template #input>
              <van-uploader
                :max-count="1" 
                :before-read="beforeImgUpload" 
                :fileList="homePage.homeVisionImgArr" 
                :after-read="(e) => uploadImg(e, 'homeVisionImg')"
                @delete="(e) => deleteImg('homeVisionImg')"
              />
            </template>
          </van-field>
          <p class="title">
            动态小图
            <span></span>
          </p>
          <div class="img-box">
            <van-field 
              v-model="homePage.dynamicImg1"
              :rules="[{ required: true, message: '请上传动态小图' }]"
            >
              <template #input>
                <van-uploader
                  :max-count="1" 
                  :before-read="beforeImgUpload" 
                  :fileList="homePage.dynamicImg1Arr" 
                  :after-read="(e) => uploadImg(e, 'dynamicImg1')"
                  @delete="(e) => deleteImg('dynamicImg1')"
                />
              </template>
            </van-field>
            <van-field 
              v-model="homePage.dynamicImg2"
              :rules="[{ required: true, message: '请上传动态小图' }]"
            >
              <template #input>
                <van-uploader
                  :max-count="1" 
                  :before-read="beforeImgUpload" 
                  :fileList="homePage.dynamicImg2Arr" 
                  :after-read="(e) => uploadImg(e, 'dynamicImg2')"
                  @delete="(e) => deleteImg('dynamicImg2')"
                />
              </template>
            </van-field>
            <van-field 
              v-model="homePage.dynamicImg3"
              :rules="[{ required: true, message: '请上传动态小图' }]"
            >
              <template #input>
                <van-uploader
                  :max-count="1" 
                  :before-read="beforeImgUpload" 
                  :fileList="homePage.dynamicImg3Arr" 
                  :after-read="(e) => uploadImg(e, 'dynamicImg3')"
                  @delete="(e) => deleteImg('dynamicImg3')"
                />
              </template>
            </van-field>
          </div>
        </van-form>
        <div class="footer">
          <div class="button cancel" @click="cancel">取消</div>
          <div class="button" @click="submit">保存</div>
        </div>
         <div style="height:66px"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    isAddHomePop: {
      type: Boolean,
      default: false
    },
    homePage: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  computed: {
    showPop: {
      get() {
        return this.isAddHomePop
      },
      set(val) {
        this.$emit('update:isAddHomePop', val)
      }
    },
    from() {
      return this.$route.query.from
    }
  },
  data() {
    return {
      isUploadImg: false,
      headImgList: [],
    }
  },
  
  methods: {
    onCancel() {
      this.isPicker = false
    },
    beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }
      return true;
    },
    uploadImg(e, field) {
      this.uploadImgFn(e, field)
    },
    uploadImgFn(e, field) {
      this.isUploadImg = true
      const currentFile = {
        url: '',
        status:'uploading',
        message: '上传中...'
      }
      this.homePage[`${field}Arr`].push(currentFile)
      this.$api.common.uploadImg(e.file)
        .then(({data}) => {
          if (data && data[0]) {
            const fileUrl = data[0].fileUrl;
            currentFile.url = fileUrl
            this.homePage[field] = fileUrl
            currentFile.status = 'done'
            delete this.homePage[field][0].status
            delete this.homePage[field][0].message
            this.isUploadImg = false
          }
        })
        .catch(err => {
          this.homePage[field] = []
          this.homePage[`${field}Arr`] = ''
      });
    },
    deleteImg(field) {
      this.homePage[field] = ''
      this.homePage[`${field}Arr`] = []
    },
   
    submit() {
      // 图片上传中
      if (this.isUploadImg) return
        this.$refs.form.validate().then(async res => {
          if (this.from == 'manager') {
            const {activityId,id=''} = this.homePage
            await this.$api.typeTest.saveStylePage({
              id,
              activityId,
              pageType: 'home',
              pageMap:this.homePage
            })
          }
          this.$emit('homePageSaveSuccess', this.homePage)
          this.$toast('保存成功');
          this.showPop = false
        }).catch(err => {
          this.$toast(err[0].message);
        })
    },
    cancel() {
      this.showPop = false
      this.isClike = true
    },
  },
  mounted() {
  },
}
</script>

<style lang="stylus" scoped>
.content {
  .form {
    height: 70vh;
    overflow: hidden;
    overflow-y: auto;
    .title {
      padding: 0 20px;
      position: relative;
      ::before {
        position: absolute;
        left: 10px;
        color: #ee0a24;
        font-size: 14px;
        content: '*';
      }
    }
    
    .img-box {
      display: flex;
      justify-content: space-between;
    }
  }
  .tips {
    font-size: 10px;
    color: #bbb;
    margin: 6px 0 6px 10px;
  }
  .serial-no {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #606266;
    font-weight: 600;
    height: 30px;
    margin: 0 15px;
    .replace {
      color: #ff6b31;
    }
  }
  .footer {
    box-sizing: border-box
    position absolute;
    left 0
    bottom 0
    height 60px
    width 100%
    display: flex
    align-items: center
    justify-content: space-around
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    border-bottom-left-radius: 16px
    border-bottom-right-radius: 16px
    background-color #fff;
    .button {
      padding 10px 40px
      border 1px solid $mainTextColor
      border-radius: 8px
      color #fff
      background-color: $mainTextColor
    }
    .cancel {
      color $mainTextColor
      background: #fff;
    }
  }
  .h5-cropper {
    position: absolute;
    left: -1000px;
    background: red;
  }
}
</style>